import React from "react";
import { Link } from "react-router-dom";
import lightLogo from '../../assets/images/logo-light.png'


const FooterFour = () => {
  return (
    <>
      <footer className="bg-themedark pt-[60px]">
        <div className="container">
          <div className="items-center grid md:grid-cols-3 grid-cols-1 gap-[30px]">
            <div>
              <img src={lightLogo} alt="logo-light" className="h-[30px]" />
            </div>
            <div className="md:col-span-2">
              <ul className="flex flex-col md:flex-row md:items-center justify-end text-left md:text-right gap-y-2.5">
                <li className="text-white/50 hover:text-white after:hidden duration-300 md:after:inline-block md:after:text-white md:after:mx-5 md:after:top-0 md:after:relative md:after:content-['-']">
                  <Link to="#">Home</Link>
                </li>
                <li className="text-white/50 hover:text-white after:hidden duration-300 md:after:inline-block md:after:text-white md:after:mx-5 md:after:top-0 md:after:relative md:after:content-['-']">
                  <Link to="#">Product</Link>
                </li>
                <li className="text-white/50 hover:text-white after:hidden duration-300 md:after:inline-block md:after:text-white md:after:mx-5 md:after:top-0 md:after:relative md:after:content-['-']">
                  <Link to="#">Services</Link>
                </li>
                <li className="text-white/50 hover:text-white duration-300">
                  <Link to="#">Services</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-white/[0.07] h-[1px] w-full inline-block mt-12"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 items-center py-4 gap-[30px]">
            <div>
              <p className="text-white/70">
                &copy; {`${new Date().getFullYear()} Landik. Design and coded by ThemesBoss.`} 
              </p>
            </div>
            <div>
              <ul className="flex items-center space-x-3 md:justify-end">
                <span className="inline-block text-white/70">Follow Us :</span>
                <li>
                  <Link
                    to="#"
                    className="text-white w-[38px] h-[38px] leading-[38px] hover:text-custom duration-300 hover:-translate-y-1 rounded-full block bg-white/5 text-lg text-center"
                  >
                    <i className="mdi mdi-facebook"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-white w-[38px] h-[38px] leading-[38px] hover:text-custom duration-300 hover:-translate-y-1 rounded-full block bg-white/5 text-lg text-center"
                  >
                    <i className="mdi mdi-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="text-white w-[38px] h-[38px] leading-[38px] hover:text-custom duration-300 hover:-translate-y-1 rounded-full block bg-white/5 text-lg text-center"
                  >
                    <i className="mdi mdi-reddit"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterFour;
